document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('[role="tab"]');
  const tabList = document.querySelector('[role="tablist"]');

  // Add a click event handler to each tab
  tabs.forEach((tab) => {
    tab.addEventListener('click', changeTabs);
  });

  // Enable arrow navigation between tabs in the tab list
  let tabFocus = 0;

  tabList.addEventListener('keydown', (e) => {
    const leftKey = 'ArrowLeft';
    const rightKey = 'ArrowRight';

    if (e.key === rightKey || e.key === leftKey) {
      tabs[tabFocus].setAttribute('tabindex', -1);

      if (e.key === rightKey) {
        tabFocus = (tabFocus + 1) % tabs.length;
      } else if (e.key === leftKey) {
        tabFocus = (tabFocus - 1 + tabs.length) % tabs.length;
      }

      tabs[tabFocus].setAttribute('tabindex', 0);
      tabs[tabFocus].focus();
    }
  });
});

function changeTabs(event) {
  const target = event.currentTarget;
  const tabList = target.closest('[role="tablist"]');
  const tabPanels = tabList.parentNode.querySelectorAll('[role="tabpanel"]');

  // Remove all current selected tabs
  tabList.querySelectorAll('[aria-selected="true"]').forEach((node) => node.setAttribute('aria-selected', false));

  // Set this tab as selected
  target.setAttribute('aria-selected', true);

  // Hide all tab panels
  tabPanels.forEach((panel) => panel.setAttribute('hidden', true));

  // Show the selected panel
  const tabPanel = document.getElementById(target.getAttribute('aria-controls'));
  if (tabPanel) {
    tabPanel.removeAttribute('hidden');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const tabPanels = document.querySelectorAll('[role="tabpanel"]');

  // Add a click event handler to each tab
  tabPanels.forEach((tabPanel) => {
    const details = tabPanel.querySelectorAll('.accordion > details');
    details.forEach((detail) => {
      detail.addEventListener('click', closeAccordions);
    });
  });
});

function closeAccordions(event) {
  const target = event.currentTarget;
  const container = target.closest('[role="tabpanel"]');
  const details = container.querySelectorAll('details');

  details.forEach((detail) => {
    if (detail !== target) {
      detail.open = false;
      detail.querySelector('summary').setAttribute('aria-expanded', false);
    }
  });


}
